// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditDelayProfileModalContent-deleteButton-3gbF2 Button-button-2PYOE Link-link-1rgM9"};